import React from "react";

export default function Footer() {
  return (
    <footer>
      <a
        href="https://github.com/ssrome/dictionary-react"
        target="_blank"
        rel="noreferrer"
      >
        Open source code
      </a>{" "}
      by Sabrina Samuel
    </footer>
  );
}
